import { storage } from '@/utils/storage';

import { useQuery } from '@tanstack/react-query';

export const useGetLanguage = () => {
  const { data } = useQuery({
    queryKey: ['lang'],
    queryFn: () => storage.getItem('lang'),
  });

  if (!data) return 'en';

  return data;
};
